import { Link } from "react-router-dom";

export const BrandFooter = () => (
  <footer className="mt-12 pt-6 border-t border-white/5" data-testid="brand-footer">
    <div className="flex flex-col sm:flex-row items-center justify-between gap-3 pb-6">
      <div className="font-mono-uc text-[10px] uppercase tracking-[0.3em] text-white/30">
        THE SOVEREIGN UMBRELLA COMMAND · SECURE · v3.1
      </div>
      <nav className="flex items-center gap-5 flex-wrap justify-center">
        {[["/handbook", "Handbook", "footer-link-handbook"],
          ["/security", "Security", "footer-link-security"],
          ["/terms", "Terms", "footer-link-terms"],
          ["/privacy", "Privacy", "footer-link-privacy"]].map(([to, label, tid]) => (
          <Link key={to} to={to} data-testid={tid}
                className="font-mono-uc text-[10px] uppercase tracking-widest text-white/40 hover:text-amber-400 transition-colors">
            {label}
          </Link>
        ))}
      </nav>
    </div>
  </footer>
);
